// extracted by mini-css-extract-plugin
export default {"info-block":"InfoBlock_info-block__ThWpc","info-block-item":"InfoBlock_info-block-item__xVpAn"};